/* The sticky category bar on the menu: which chip is lit.
 *
 * The bar itself is markup and CSS and works without this file - the chips are anchors. This only
 * marks the section you are actually in and slides that chip into view, so after a few screens of
 * scrolling the bar still tells you where you are.
 *
 * The concept runtime re-renders its tree, which throws away the observer and the markup with it,
 * so the whole thing re-arms whenever the bar reappears.
 */
(function () {
  var BAR = '.bc-jumpbar';
  var observer = null;
  var watched = null;

  function arm() {
    var bar = document.querySelector(BAR);
    if (!bar || bar === watched) return;

    var chips = Array.prototype.slice.call(bar.querySelectorAll('a[href^="#"]'));
    if (!chips.length) return;

    var sections = chips
      .map(function (chip) {
        var id = chip.getAttribute('href').slice(1);
        var section = document.getElementById(id);
        return section ? { chip: chip, section: section } : null;
      })
      .filter(Boolean);
    if (!sections.length) return;

    if (observer) observer.disconnect();
    watched = bar;

    // The concept header is sticky on some pages and not on others - an ancestor with overflow
    // cancels it - so the bar asks rather than assumes. Sticky, it parks underneath; otherwise it
    // takes the top of the screen for itself.
    var chrome = 0;

    function place() {
      var header = document.querySelector('.bc-concept-mount #dc-root header');
      var top = header && getComputedStyle(header).position === 'sticky'
        ? Math.round(header.getBoundingClientRect().height)
        : 0;
      bar.style.top = top + 'px';
      chrome = top + bar.offsetHeight;
      sections.forEach(function (entry) {
        entry.section.style.scrollMarginTop = (chrome + 8) + 'px';
      });
    }

    place();
    window.addEventListener('resize', place);

    var current = null;

    function light(entry) {
      if (!entry || entry.chip === current) return;
      chips.forEach(function (chip) { chip.removeAttribute('aria-current'); });
      entry.chip.setAttribute('aria-current', 'true');
      current = entry.chip;
      // Keep the lit chip on screen without dragging the page with it.
      var barBox = bar.getBoundingClientRect();
      var chipBox = entry.chip.getBoundingClientRect();
      if (chipBox.left < barBox.left + 8 || chipBox.right > barBox.right - 8) {
        bar.scrollTo({ left: bar.scrollLeft + (chipBox.left - barBox.left) - 20, behavior: 'smooth' });
      }
    }

    observer = new IntersectionObserver(
      function () {
        // The section whose top is nearest the bar, without having passed it.
        var best = null;
        sections.forEach(function (entry) {
          // Measured against the bottom of the chrome, not the top of the window: the section you
          // are reading is the one whose heading has just gone under the bar.
          var top = entry.section.getBoundingClientRect().top - (chrome + 12);
          if (top <= 0 && (!best || top > best.top)) best = { top: top, chip: entry.chip };
        });
        light(best || { chip: sections[0].chip });
      },
      { rootMargin: '0px 0px -70% 0px', threshold: [0, 0.01, 0.25, 0.5] }
    );

    sections.forEach(function (entry) { observer.observe(entry.section); });
  }

  function boot() {
    arm();
    new MutationObserver(function () {
      if (!document.contains(watched)) watched = null;
      arm();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
